import NutritionInformationService from 'src/modules/nutritionInformation/nutritionInformationService';
import Errors from 'src/modules/shared/error/errors';
import { navigateTo } from 'src/view/shared/routes/helpers';

const prefix = 'NUTRITIONINFORMATION_VIEW';

const nutritionInformationViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,
  FIND_RESET: `${prefix}_FIND_RESET`,

  reset: () => async (dispatch) => {
    dispatch({
      type: nutritionInformationViewActions.FIND_RESET,
    });
  },

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: nutritionInformationViewActions.FIND_STARTED,
      });

      const record = await NutritionInformationService.find(id);

      dispatch({
        type: nutritionInformationViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: nutritionInformationViewActions.FIND_ERROR,
      });

      navigateTo('/library/nutrition-information');
    }
  },
};

export default nutritionInformationViewActions;
